import EditMobile from './EditMobile'
export default EditMobile
